export enum StepRuleType {
  TOTAL_SCORE = 'TOTAL_SCORE',
  AVERAGE_SCORE = 'AVERAGE_SCORE',
}